<template>
    <div
            @mouseover="toggleMenu(false)"
            @mouseleave="toggleMenu(true)">
        <v-navigation-drawer
                id="core-navigation-drawer"
                fixed permanent app
                :mini-variant.sync="drawer"
                width=260
        >
            <v-list
                    dense
                    nav
                    class="px-0"
            >
                <v-list-item>
                    <v-list-item-content
                            class="align-self-center"
                            color="white"
                            contain
                    >
                        <v-img
                                src="/assets/img/logo-long.png"
                                height="54"
                                class="mx-auto logo-top"
                        />
                    </v-list-item-content>
                </v-list-item>
            </v-list>

            <v-list
                    expand
                    nav
                    class="px-0"
            >
                <!-- Style cascading bug  -->
                <!-- https://github.com/vuetifyjs/vuetify/pull/8574 -->
                <div/>

                <template v-for="(item, i) in computedItems">
                    <base-item-group
                            v-if="item.children"
                            :key="`group-${i}`"
                            :item="item"
                            class="font-weight-bold"
                    >
                        <!--  -->
                    </base-item-group>


                    <v-list-group sub-group v-if="item.subLinks" :key="`item-${i}`" class="subMenu" value="true">
                        <v-list slot="activator" class="list-tile" style="position: static !important">
                            <base-item
                                    :key="`item-${i}`"
                                    :item="item"
                                    class="mb-0"
                            />
                        </v-list>
                        <v-list v-for="(sublink, i) in item.subLinks" :key="`sublink-${i}`">
                            <base-item
                                    :key="`sublink-${i}`"
                                    :item="sublink"
                            />
                        </v-list>
                    </v-list-group>
                    <base-item
                            v-else
                            :key="`item-${i}`"
                            :item="item"
                    />

                </template>

                <!-- Style cascading bug  -->
                <!-- https://github.com/vuetifyjs/vuetify/pull/8574 -->
                <div/>
            </v-list>

            <template v-slot:append>
                <div class="pb-3">
                    <base-item
                            class="pl-1 mb-3"
                            :item="{
              title: $t('user'),
              icon: '$user_config',
              to: '/parametre',
            }"
                    />

                    <a class="btn-logout noneRipple ml-4 mb-3" text @click="logout">
                        <v-icon v-text="'$power_off'"></v-icon>
                    </a>
                </div>
            </template>
        </v-navigation-drawer>
    </div>
</template>

<script>
  // Utilities
  import {
    mapState,
  } from 'vuex'
  import i18n from "@/i18n";
  import {AUTH_LOGIN, AUTH_LOGOUT, NAVIGATION_SET_DRAWER} from '../store/mutation-types';

  export default {
    name: 'DashboardCoreDrawer',

    props: {
      expandOnHover: {
        type: Boolean,
        default: true,
      },
    },

    data: () => ({
      items: [
        {
          icon: 'fal fa-clone',
          title: 'Nouveau comptage',
          to: {name: 'search.index'}
        },
        {
          icon: 'fal fa-copy',
          title: 'Comptages sauvegardés',
          to: '/comptages-sauvegardes',
        },
        // {
        //   icon: 'fal fa-database',
        //   title: 'Devis',
        //   to: '/devis',
        // },
        // {
        //   icon: 'fal fa-bullseye-pointer',
        //   title: 'Campagnes',
        //   to: '/campagnes',
        // },
        {
          icon: 'fal fa-chart-bar',
          title: 'Statistiques',
          to: '/statistiques',
        },
        {
          icon: 'fal fa-users',
          title: 'Clients',
          to: '/clients',
        },
        {
          icon: 'fal fa-bell',
          title: 'Notification',
          to: '/notifications',
        },
        {
          title: i18n.t('Databases'),
          icon: 'fal fa-user',
          to: '/databases',
          subLinks: [
            {
              title: i18n.t('Non-enregistrer'),
              to: '/non-enregistrer',
            }
          ]
        },
      ],
    }),

    computed: {
      ...mapState({
        drawer: state => state.navigation.drawer
      }),
      computedItems() {
        return this.items.map(this.mapItem)
      },
      profile() {
        return {
          avatar: true,
          title: this.$t('avatar'),
        }
      }
    },

    methods: {
      async logout() {
        await this.$store.dispatch(AUTH_LOGOUT);
      },
      mapItem(item) {
        return {
          ...item,
          children: item.children ? item.children.map(this.mapItem) : undefined,
          title: this.$t(item.title),
        }
      },

      toggleMenu(status) {
        this.$store.commit(NAVIGATION_SET_DRAWER, status);
      }
    },
  }
</script>

<style lang="sass">
    @import '~vuetify/src/styles/tools/_rtl.sass'

    #core-navigation-drawer
        background-color: #F6F6F6

        .v-list-group__header.v-list-item--active:before
            opacity: .24

        .v-list-item
            &__icon--text,
            &__icon:first-child
                justify-content: center
                text-align: center
                width: 20px

                +ltr()
                    margin-right: 24px
                    margin-left: 12px !important

                +rtl()
                    margin-left: 24px
                    margin-right: 12px !important

        .v-list--dense
            .v-list-item
                &__icon--text,
                &__icon:first-child
                    margin-top: 10px

        .v-list-group--sub-group
            .v-list-item
                +ltr()
                    padding-left: 8px

                +rtl()
                    padding-right: 8px

            .v-list-group__header
                +ltr()
                    padding-right: 0

                +rtl()
                    padding-right: 0

                .v-list-item__icon--text
                    margin-top: 19px
                    order: 0

                .v-list-group__header__prepend-icon
                    order: 2

                    +ltr()
                        margin-right: 8px

                    +rtl()
                        margin-left: 8px
</style>
